export default {
  planList: [],
  plan: null,
  selectedPlan: {}, // 포인캠퍼스 > 요금 플랜 페이지 > 선택한 요금제 정보
};
